module.exports = __webpack_public_path__ + "static/media/add_icon.93007831.svg";